<template>
  <div>
    <LoadingWrapper :state="status">
      <CoacheeDialogCard
        v-if="data.latestDialog"
        :dialog="data.latestDialog"
        as-coach
        @dateSet="reload"
      />
      <div v-if="data.conductedDialogs.length" class="flex flex-col">
        <h2 class="text-title-medium text-on-surface-variant mt-10 mb-1">Abgeschlossene Dialoge</h2>
        <ul class="flex flex-col gap-0.5">
          <ConductedDialogItem
            v-for="dialog in data.conductedDialogs"
            :key="dialog.id"
            :conducted-dialog="dialog"
            @click="navigateToDialog(dialog.id)"
          />
        </ul>
      </div>
      <div v-if="data.conductedDialogs.length === 0 && !data.latestDialog">
        <span class="text-body-medium text-on-surface-variant">{{
          $t('coaching.dialogs.empty.title')
        }}</span>
      </div>
    </LoadingWrapper>
  </div>
</template>

<script lang="ts" setup>
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import { useCoacheeDialog } from '../composables/useCoacheeDialog'
  import CoacheeDialogCard from '../components/CoacheeDialogCard.vue'
  import ConductedDialogItem from '@/modules/dialog/components/ConductedDialogItem.vue'
  import { useRouter } from 'vue-router'

  const router = useRouter()
  const { data, status, reload } = useCoacheeDialog()

  const navigateToDialog = (dialogId: string) => {
    router.push({ name: 'dialog', params: { id: dialogId } })
  }
</script>
